import {Component, Plugins} from '@packages/systems/wfdl';
import {ELiteral} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {type BreakpointID} from '@packages/systems/style/types';
import {type BindableColorValue} from '@packages/systems/component-canvas/types';
import {
  setFrameSetting,
  resetFrameSetting,
  type GetBaseVariantId,
  getBaseVariantIdForNativeComponent,
} from './frameUtils';

const bindableColorTypeName = qualify(
  Plugins.name('Frame'),
  typeName('BindableColor')
);

const defaultColorExpr = ELiteral({
  name: bindableColorTypeName,
  value: {type: 'body-background-color'},
});

export function setFrameBackgroundColor(
  componentMap: Component.ComponentMap,
  frameId: string,
  mediaQuery: BreakpointID,
  value: BindableColorValue,
  getBaseVariantId: GetBaseVariantId = getBaseVariantIdForNativeComponent
) {
  return setFrameSetting(
    componentMap,
    frameId,
    mediaQuery,
    'color',
    ELiteral({
      name: bindableColorTypeName,
      value,
    }),
    getBaseVariantId
  );
}

export function resetFrameBackgroundColor(
  componentMap: Component.ComponentMap,
  frameId: string,
  mediaQuery: BreakpointID,
  getBaseVariantId: GetBaseVariantId = getBaseVariantIdForNativeComponent
) {
  return resetFrameSetting(
    componentMap,
    frameId,
    mediaQuery,
    'color',
    defaultColorExpr,
    getBaseVariantId
  );
}
